<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card :loading="loading" class="mx-auto">
        <v-card-title>
          <span class="headline">ACTUALIZAR ESTADO LOGIN</span>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="text--primary px-8">
          <div class="grey--text text--darken-3 px-4 pt-4">
            <v-radio-group v-model="estadoLogin" column>
              <v-radio
                class="px-5 prueba"
                v-for="(item, i) in estados"
                @click="updateEstado()"
                :key="i"
                :disabled="item.value"
                :label="item.title"
                :value="item.value"
              ></v-radio>
            </v-radio-group>
          </div>
        </v-card-text>

        <v-card-actions class="pb-8 pl-8">
          <v-btn color="warning" dark @click="cerrarModal"> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// import { mapState } from "vuex";
import { db } from "../../firebase";
export default {
  name: "ModAddEstadoLogin",
  data: () => ({
    loading: false,
    dialog: true,
    estadoLogin: false,
    datosUsuario: {},
    estados: [
      {
        title: "LOGUEADO",
        value: true,
      },
      {
        title: "DESLOGUEAR",
        value: false,
      },
    ],
  }),
  props: {
    id: { type: String, default: "" },
    showModal: { type: Boolean, default: false },
  },
  async mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      this.datosUsuario = await db.collection("usuarios").doc(this.id).get();
      this.estadoLogin = this.datosUsuario.data().login
        ? this.datosUsuario.data().login
        : false;
      this.loading = false;
    },
    async updateEstado() {
      const swal = await this.$swal({
        title: "Actualizar estado login",
        text: `¿Esta seguro de actualizar?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Si, Actualizar !!",
        cancelButtonText: "No",
        cancelButtonColor: "#d33",
      });
      if (swal.isConfirmed) {
        try {
          this.$store.dispatch("ActualizarLoginUsuario", {
            id: this.id,
            login: this.estadoLogin,
            ip: "",
            salir: false,
          });
          this.$swal({ icon: "success", title: "Operación Exitosa", text: "" });
          this.cerrarModal();
          this.$emit("actualizar");
        } catch (error) {
          this.handleError(error);
        }
      } else {
        this.estadoLogin = this.datosUsuario.data().login
          ? this.datosUsuario.data().login
          : false;
      }
    },
    cerrarModal() {
      this.$emit("update:showModal", !this.showModal);
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.div-opciones
    overflow: auto
    height: 240px
</style>
